import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";

type FileRevision = {
  revision: number;
};

export const deleteFile = async (fileId: string) => {
  const { data: file } =
    await authenticatedFastApiAxiosInstance.get<FileRevision>(
      `files/${fileId}`,
    );

  await authenticatedFastApiAxiosInstance.delete(`files/${fileId}`, {
    params: { revision: file.revision },
  });
};
